module.exports = __webpack_public_path__ + "img/icon-format.1ceacb9d.svg";